import { useMutation } from '@tanstack/react-query';

import { updateAffiliationUsersTier } from '~/services/AgentHub/AgentService';

import { Tier } from '~/types/services/agentHub';

interface UpdateAffiliationUsersTierVariables {
  name: string;
  region: string;
  tier: Tier;
}

interface UseUpdateAffiliationUsersTierOptions {
  onSuccess?: () => void;
  onError?: (error: Error) => void;
}

export function useUpdateAffiliationUsersTier(options: UseUpdateAffiliationUsersTierOptions = {}) {
  return useMutation({
    mutationFn: async ({ name, region, tier }: UpdateAffiliationUsersTierVariables) => {
      return await updateAffiliationUsersTier(name, region, tier);
    },
    onSuccess: () => {
      options.onSuccess?.();
    },
    onError: (error: Error) => {
      options.onError?.(error);
    },
  });
}
